<div class="container-fluid cloze-test-container" [style.font-family]="clozeTestStyleModel().font"
    [style.font-size]="mobileMode() ? '16px' : clozeTestStyleModel().fontSize">

    @if (headerLogo() || headerLogoTitle() || headerTitle()) {
    <div class="cloze-test-header">

        <div class="cloze-test-header-logo">
            <img [src]="headerLogo()" alt="">

            <div class="cloze-test-header-logo-title">
                @if (headerLogoTitleImage()) {
                <img [src]="headerLogoTitleImage()" [alt]="headerLogoTitle()">
                } @else {
                {{ headerLogoTitle() }}
                }
            </div>
        </div>

        <div class="cloze-test-header-title">
            {{ headerTitle() }}
        </div>

    </div>
    }

    <div class="cloze-test-body"
        [style.background-color]="mobileMode() ? '#FFFFFFFF' : clozeTestStyleModel().siteBackground">

        <div class="cloze-test-content">
            @if (!isTestStarted && !isTestExampleStarted && !isTestOver) {
                @if (introductionType() === IntroductionType.INTRO) {
                <cloze-test-introduction [title]="startPageTitle" [subtitle]="startPageSubtitle" [totalExercise]="0"
                    [currentExerciseNumber]="currentExercise" [content]="startPageContent"
                    [clozeTestStyleModel]="clozeTestStyleModel()" [cTestLogo]="cTestLogo"
                    [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode()"
                    [showExerciseExample]="showExerciseExample()" [lang]="lang()"
                    (startTest)="onStartTest($event)" (startTestExample)="onStartTestExample()">
                </cloze-test-introduction>
                }
                @if (introductionType() === IntroductionType.INTRO_SHORT) {
                <cloze-test-introduction-short [clozeTestStyleModel]="clozeTestStyleModel()" [lang]="lang()"
                    [mobileMode]="mobileMode()" [showExerciseExample]="showExerciseExample()"
                    (startTest)="onStartTest($event)" (startTestExample)="onStartTestExample()">
                </cloze-test-introduction-short>
                }
            }

            @if (!isTestStarted && isTestExampleStarted) {
            <cloze-test-exercise-example [clozeTestStyleModel]="clozeTestStyleModel()" [cTestLogo]="cTestLogo"
                [mobileMode]="mobileMode()" [lang]="lang()" [cTestButtonColor]="cTestButtonColor"
                (startTest)="onStartTest($event)">
            </cloze-test-exercise-example>
            }

            @if (isInvalidToken) {
            <cloze-test-invalid-token [clozeTestStyleModel]="clozeTestStyleModel()"
                [mobileMode]="mobileMode()" [lang]="lang()"></cloze-test-invalid-token>
            }

            @if (isTestStarted && !isTestOver && !isLoadingTask && !isInvalidToken) {
            <cloze-test-exercise [title]="exerciseTitle" [content]="exerciseContent" [isLastExercise]="isLastExercise"
                [currentExcerciseNumber]="currentExercise" [lastExerciseNumber]="totalExercises"
                [totalExercise]="totalExercises ?? 0" [clozeTestStyleModel]="clozeTestStyleModel()"
                [bookingId]="bookingId" [exerciseId]="exerciseId" [serviceUrl]="clozeTestModel().onsetServiceUrl"
                [cTestLogo]="cTestLogo" [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode()"
                [lang]="lang()"
                (nextExercise)="onNextExercise($event)" (endTest)="onTestEnd($event)"></cloze-test-exercise>
            }

            @if (isTestOver) {
            <cloze-test-result [results]="currentResults()" [showResult]="showResult()"
                [clozeTestStyleModel]="clozeTestStyleModel()" [totalExercise]="currentExercise"
                [currentExerciseNumber]="currentExercise" [cTestLogo]="cTestLogo" [cTestButtonColor]="cTestButtonColor"
                [mobileMode]="mobileMode()" [showEndTestButton]="showEndTestButton()"
                [lang]="lang()" (clozeTest)="onClozeTest($event)">
            </cloze-test-result>
            }
        </div>

    </div>

</div>

@if (mobileMode() && (isTestStarted && !isTestOver) || isTestExampleStarted) {
<cloze-test-mobile-keyboard [lang]="lang()"></cloze-test-mobile-keyboard>
}